(function () {
  console.log('[TD] custom.js v11 loaded');
  const escapeValue = (value) => {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(String(value));
    }
    return String(value).replace(/"/g, '\\"');
  };

  const initDeliveryTime = () => {
    const containers = document.querySelectorAll('[data-td-delivery-time]');
    if (!containers.length) return;

    const getSelectedVariantId = (container) => {
      const form = container.closest('section')?.querySelector('form[action*="/cart/add"]') ||
        document.querySelector('form[action*="/cart/add"]');
      return form?.querySelector('input[name="id"]')?.value || null;
    };

    const showVariantBlock = (container, variantId) => {
      if (!variantId) return;
      const blocks = container.querySelectorAll('.td-delivery-time__item');
      blocks.forEach((block) => block.classList.add('is-hidden'));
      const active = container.querySelector(
        `.td-delivery-time__item[data-variant-id="${escapeValue(variantId)}"]`
      );
      if (active) active.classList.remove('is-hidden');
    };

    const refreshAll = () => {
      containers.forEach((container) => {
        const variantId = getSelectedVariantId(container);
        showVariantBlock(container, variantId);
      });
    };

    refreshAll();

    document.addEventListener('variant:change', refreshAll);
    document.addEventListener('product:variant-change', refreshAll);

    document.body.addEventListener('change', (event) => {
      if (event.target.matches('select[name^="options"], select[name^="SingleOptionSelector"], input[type="radio"][name^="options"]')) {
        requestAnimationFrame(refreshAll);
      }
    });

    document.body.addEventListener('click', (event) => {
      if (event.target.closest('[data-option], .product-form__input, .swatch, .variant-swatch, .product-option')) {
        setTimeout(refreshAll, 0);
      }
    });

    const idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (idInput && window.MutationObserver) {
      const observer = new MutationObserver(refreshAll);
      observer.observe(idInput, { attributes: true, attributeFilter: ['value'] });
    }
  };

  const initTdVariantPicker = () => {
    const getContainers = () => document.querySelectorAll('[data-td-variant-picker]');

    const toggleByIdPrefix = (container, prefix, variantId) => {
      const items = container.querySelectorAll(`[id^="${prefix}_"]`);
      if (!items.length) return;

      items.forEach((item) => item.classList.add('hide'));
      if (!variantId) return;

      const target = container.querySelector(`#${prefix}_${escapeValue(variantId)}`);
      if (target) target.classList.remove('hide');
    };

    const toggleWeightOptvalFallback = (container, variantId) => {
      const optvalDivs = container.querySelectorAll('[data-td-weight-optval]');
      if (!optvalDivs.length) return;

      optvalDivs.forEach((d) => d.classList.add('hide'));

      if (variantId) {
        const variantDiv = container.querySelector(`#weight_info_${escapeValue(variantId)}`);
        if (variantDiv) return;
      }

      const fieldset = optvalDivs[0].closest('fieldset');
      if (!fieldset) return;

      const checked = fieldset.querySelector('input[type="radio"]:checked');
      if (!checked) return;

      const selectedVal = (checked.dataset.optionValue || '').trim();
      optvalDivs.forEach((d) => {
        if (d.dataset.tdWeightOptval === selectedVal) {
          d.classList.remove('hide');
        }
      });
    };

    const getSelectedOptions = (container, variant) => {
      if (variant && variant.id) {
        const selectedFromVariant = {};
        if (variant.option1) selectedFromVariant['1'] = variant.option1;
        if (variant.option2) selectedFromVariant['2'] = variant.option2;
        if (variant.option3) selectedFromVariant['3'] = variant.option3;
        return selectedFromVariant;
      }

      const selected = {};
      container.querySelectorAll('input[data-option-position]:checked').forEach((input) => {
        const position = input.dataset.optionPosition;
        if (!position) return;

        let value = input.getAttribute('data-option-value');
        if (!value) {
          const label =
            container.querySelector(`label[for="${escapeValue(input.id)}"]`) ||
            input.closest('label');
          if (label) {
            const textNode = label.querySelector('span:not(.block-swatch__color):not(.sr-only)') || label;
            value = textNode.textContent;
          }
        }

        if (value) selected[position] = value.trim();
      });
      return selected;
    };

    const getVariantIdFromContainer = (container) => {
      const formId = container.dataset.formId;
      if (!formId) return null;
      const form = document.forms[formId];
      return form?.querySelector('input[name="id"]')?.value || null;
    };

    const updateBadges = (container, selectedOptions, variantId) => {
      const badges = container.querySelectorAll('[data-td-badge]');
      if (!badges.length) return;

      badges.forEach((badge) => badge.classList.add('td-variant-badge--hidden'));
      if (!variantId) return;

      const option1 = selectedOptions?.['1'];
      const option2 = selectedOptions?.['2'];
      if (!option1 && !option2) return;

      badges.forEach((badge) => {
        if (badge.dataset.variantOption1 === option1 && badge.dataset.variantOption2 === option2) {
          badge.classList.remove('td-variant-badge--hidden');
        }
      });
    };

    const updateSelectedValueLabels = (container, selectedOptions, variantId) => {
      if (!variantId) return;
      const cardFieldsets = container.querySelectorAll('[data-td-card-swatch="true"]');
      if (!cardFieldsets.length) return;

      cardFieldsets.forEach((fieldset) => {
        const optionPosition = fieldset.dataset.tdOptionPosition;
        if (!optionPosition) return;

        const text = selectedOptions?.[optionPosition];
        if (!text) return;

        const target = fieldset.querySelector('[data-td-option-selected-value]');
        if (target) target.textContent = text;
      });
    };

    /* ---------------------------------------------------------
       Hide unavailable option values
       ---------------------------------------------------------
       Uses inline styles on wrapper elements to show/hide option
       values based on cascading availability.
       Called from variant:change, product:rerender, and direct
       change/click listeners to keep the filter in sync.
       --------------------------------------------------------- */
    const applyUnavailableFilter = (container, variant) => {
      if (!container.hasAttribute('data-hide-unavailable')) return;

      const script = container.querySelector('script[data-td-variants-availability]');
      if (!script) return;

      let allVariants;
      try { allVariants = JSON.parse(script.textContent); } catch (e) { return; }

      const optionCount = allVariants.reduce((max, v) => {
        let c = 0;
        if (v.o1 != null) c = 1;
        if (v.o2 != null) c = 2;
        if (v.o3 != null) c = 3;
        return Math.max(max, c);
      }, 0);

      /* Read selected values from variant object (authoritative)
         or fall back to DOM on initial load */
      const selected = {};
      if (variant && variant.id) {
        if (variant.option1) selected[1] = variant.option1;
        if (variant.option2) selected[2] = variant.option2;
        if (variant.option3) selected[3] = variant.option3;
      } else {
        for (let pos = 1; pos <= optionCount; pos++) {
          const checked = container.querySelector(`input[data-option-position="${pos}"]:checked`);
          if (checked) {
            selected[pos] = checked.dataset.optionValue || '';
          }
        }
      }

      const autoSelected = new Set();

      for (let pos = 1; pos <= optionCount; pos++) {
        /* For each option: find values that can produce an available variant
           given the options ABOVE it (cascade top-down).
           Option 1 → show all, Option 2 → filter by option 1,
           Option 3 → filter by options 1+2 */
        const availableValues = new Set();
        for (const v of allVariants) {
          if (!v.a) continue;
          let matches = true;
          for (let other = 1; other < pos; other++) {
            if (selected[other] && v[`o${other}`] !== selected[other]) {
              matches = false;
              break;
            }
          }
          if (matches) availableValues.add(v[`o${pos}`]);
        }

        /* Auto-select first available value (in DOM order) when the
           current selection is unavailable — keeps the cascade valid */
        const wrappers = container.querySelectorAll(`[data-option-pos="${pos}"]`);
        if (selected[pos] && !availableValues.has(selected[pos]) && availableValues.size > 0) {
          for (const wrapper of wrappers) {
            const val = wrapper.dataset.optionVal;
            if (val && availableValues.has(val)) {
              selected[pos] = val;
              autoSelected.add(pos);
              break;
            }
          }
        }

        /* Show/hide wrapper elements via inline style */
        wrappers.forEach((wrapper) => {
          const val = wrapper.dataset.optionVal;
          if (!val) return;
          if (availableValues.has(val) || val === selected[pos]) {
            wrapper.style.removeProperty('display');
          } else {
            wrapper.style.setProperty('display', 'none', 'important');
          }
        });

        console.log('[TD filter] pos', pos, '| available:', [...availableValues], '| wrappers:', wrappers.length);
      }

      /* Check radios for auto-selected values and trigger Prestige
         to resolve the correct variant */
      if (autoSelected.size > 0) {
        let lastChanged = null;
        for (const pos of autoSelected) {
          const inputs = container.querySelectorAll(`input[data-option-position="${pos}"]`);
          for (const input of inputs) {
            if (input.dataset.optionValue === selected[pos] && !input.checked) {
              input.checked = true;
              lastChanged = input;
            }
          }
        }
        if (lastChanged) {
          lastChanged.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    };

    const updateContainer = (container, variant) => {
      const variantId = variant?.id || getVariantIdFromContainer(container);
      const selectedOptions = getSelectedOptions(container, variant);

      toggleByIdPrefix(container, 'weight_info', variantId);
      toggleWeightOptvalFallback(container, variantId);
      toggleByIdPrefix(container, 'second_weight_info', variantId);
      toggleByIdPrefix(container, 'cover_type_info', variantId);

      updateBadges(container, selectedOptions, variantId);
      updateSelectedValueLabels(container, selectedOptions, variantId);
    };

    const updateAll = () => {
      getContainers().forEach((container) => {
        updateContainer(container, null);
      });
    };

    updateAll();

    const refreshFilter = () => {
      getContainers().forEach((container) => {
        applyUnavailableFilter(container, null);
      });
    };

    /* Initial filter */
    refreshFilter();

    document.addEventListener('variant:change', (event) => {
      const variant = event.detail?.variant;
      /* Prestige dispatches on the form. event.detail.formId may be the
         <input name="id"> element (form.id shadowed by named control).
         Use event.target.getAttribute('id') for a reliable string. */
      const eventFormId = event.target?.getAttribute?.('id') || null;

      getContainers().forEach((container) => {
        if (eventFormId && container.dataset.formId && container.dataset.formId !== eventFormId) return;
        updateContainer(container, variant || null);
        applyUnavailableFilter(container, variant || null);
      });
    });

    document.addEventListener('change', (event) => {
      if (event.target.matches('form[action*="/cart/add"] input[name="id"]')) {
        updateAll();
      }
    });

    /* product:rerender does NOT bubble (Prestige dispatches with
       default bubbles:false on the form), so listen on each form directly */
    getContainers().forEach((container) => {
      const rerenderFormId = container.dataset.formId;
      if (!rerenderFormId) return;
      const rerenderForm = document.getElementById(rerenderFormId) || document.forms[rerenderFormId];
      if (!rerenderForm) return;
      rerenderForm.addEventListener('product:rerender', () => {
        getContainers().forEach((c) => {
          updateContainer(c, null);
          applyUnavailableFilter(c, null);
        });
      });
    });

    /* Direct radio/click listeners — catches option changes even if
       Prestige custom events (variant:change, product:rerender) don't fire */
    document.body.addEventListener('change', (event) => {
      if (event.target.matches('[data-td-variant-picker] input[type="radio"]') ||
          event.target.matches('[data-td-variant-picker] select')) {
        requestAnimationFrame(refreshFilter);
      }
    });

    document.body.addEventListener('click', (event) => {
      if (event.target.closest('[data-td-variant-picker] label') ||
          event.target.closest('[data-td-variant-picker] .block-swatch') ||
          event.target.closest('[data-td-variant-picker] .color-swatch') ||
          event.target.closest('[data-td-variant-picker] .td-variant-picker__value')) {
        requestAnimationFrame(() => requestAnimationFrame(refreshFilter));
      }
    });

    /* MutationObserver on variant ID input — catches changes from any source */
    getContainers().forEach((container) => {
      const formId = container.dataset.formId;
      if (!formId) return;
      const form = document.forms[formId];
      const idInput = form?.querySelector('input[name="id"]');
      if (idInput && window.MutationObserver) {
        const observer = new MutationObserver(() => {
          requestAnimationFrame(refreshFilter);
        });
        observer.observe(idInput, { attributes: true, attributeFilter: ['value'] });
      }
    });
  };

  const initTdCollectionProducts = () => {
    const getRoots = () => document.querySelectorAll('[data-td-collection-products]');

    const updateVisibility = () => {
      const isMobile = window.innerWidth < 700;

      getRoots().forEach((root) => {
        const desktopColumns = parseInt(root.dataset.desktopColumns || '4', 10);
        const desktopRows = parseInt(root.dataset.desktopRows || '1', 10);
        const mobileColumns = parseInt(root.dataset.mobileColumns || '2', 10);
        const mobileRows = parseInt(root.dataset.mobileRows || '2', 10);
        const maxVisible = isMobile ? mobileColumns * mobileRows : desktopColumns * desktopRows;
        const items = root.querySelectorAll('[data-td-collection-item]');

        items.forEach((item, index) => {
          item.hidden = index >= maxVisible;
        });
      });
    };

    const updateDynamicTitle = (root, link) => {
      if (!root || root.dataset.showDynamicTitle !== 'true') return;

      const valueNode = root.querySelector('[data-td-collection-value]');
      if (!valueNode) return;

      const productTitle = link?.dataset?.productTitle || root.dataset.defaultTitle || '';
      valueNode.textContent = productTitle;
    };

    /* TD: hover/focus selection removed — only the current product stays selected */

    updateVisibility();
    window.addEventListener('resize', updateVisibility);
    document.addEventListener('product:rerender', updateVisibility);
  };

  /* -----------------------------------------------
     TD Upsell Addon — toggle + variant resolution + cart
     ----------------------------------------------- */
  const initTdUpsellAddon = () => {
    const containers = document.querySelectorAll('[data-td-upsell-addon]');
    if (!containers.length) return;

    containers.forEach((container) => {
      const toggle = container.querySelector('[data-td-upsell-toggle]');
      const optionsArea = container.querySelector('[data-td-upsell-options]');
      const variantInput = container.querySelector('[data-td-upsell-variant-id]');
      const priceEl = container.querySelector('[data-td-upsell-price]');
      const qtyInput = container.querySelector('[data-td-upsell-qty]');
      const selects = container.querySelectorAll('[data-td-upsell-option]');
      const scriptEl = container.nextElementSibling?.matches('script[data-td-upsell-variants-json]')
        ? container.nextElementSibling
        : container.parentElement.querySelector('script[data-td-upsell-variants-json]');
      const variantsJson = scriptEl ? JSON.parse(scriptEl.textContent || '[]') : [];

      if (toggle && optionsArea) {
        toggle.addEventListener('change', () => {
          optionsArea.hidden = !toggle.checked;
        });
      }

      const formatMoney = (cents) => {
        const amount = (cents / 100).toFixed(2).replace('.', ',');
        return amount + '\u00A0\u20AC';
      };

      const compareEl = container.querySelector('[data-td-upsell-compare-price]');

      const resolveVariant = () => {
        const selectedOptions = Array.from(selects).map((s) => s.value);
        const match = variantsJson.find((v) =>
          v.options.every((opt, idx) => opt === selectedOptions[idx])
        );
        if (match && match.available !== false) {
          variantInput.value = match.id;
          if (priceEl) {
            const compareHtml = match.compare_at_price && match.compare_at_price > match.price
              ? '<s class="td-upsell-addon__compare-price" data-td-upsell-compare-price>' + formatMoney(match.compare_at_price) + '</s> '
              : '';
            priceEl.innerHTML = compareHtml + '(+ ' + formatMoney(match.price) + ')';
          }
        }
      };

      selects.forEach((s) => s.addEventListener('change', resolveVariant));

      let upsellPending = false;
      const addUpsellToCart = () => {
        if (upsellPending) return;
        if (!toggle || !toggle.checked) return;
        const vid = variantInput?.value;
        if (!vid) return;
        const qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        upsellPending = true;

        fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: qty }] })
        })
          .then((r) => {
            if (!r.ok) throw new Error('Upsell add failed');
            return r.json();
          })
          .then(() => {
            return fetch((window.Shopify?.routes?.root || '/') + 'cart.js');
          })
          .then((r) => r.json())
          .then((cart) => {
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:change', {
                bubbles: true,
                detail: { baseEvent: 'variant:add', cart: cart }
              })
            );
          })
          .catch(() => { /* silently fail if upsell product unavailable */ })
          .finally(() => { upsellPending = false; });
      };

      /* Listen for Prestige's variant:add event (fires after successful AJAX add) */
      document.addEventListener('variant:add', addUpsellToCart);
    });
  };

  const initCertificatesDots = () => {
    document.querySelectorAll('.td-certificates-dots').forEach((dotsContainer) => {
      const scrollId = dotsContainer.dataset.scrollTarget;
      const scroll = document.getElementById(scrollId);
      if (!scroll) return;

      const dots = dotsContainer.querySelectorAll('.td-certificates-dot');
      if (!dots.length) return;

      const itemsPerPage = 2;
      const getItems = () => scroll.querySelectorAll('.td-certificates-logos__item');

      const updateDots = () => {
        const items = getItems();
        if (!items.length) return;
        const itemWidth = items[0].offsetWidth;
        const gap = parseFloat(getComputedStyle(scroll).columnGap) || 0;
        const pageWidth = itemsPerPage * itemWidth + (itemsPerPage - 1) * gap;
        const currentPage = Math.round(scroll.scrollLeft / pageWidth);
        dots.forEach((dot) => {
          dot.classList.toggle('is-active', parseInt(dot.dataset.page) === currentPage);
        });
      };

      scroll.addEventListener('scroll', updateDots, { passive: true });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const page = parseInt(dot.dataset.page);
          const items = getItems();
          if (!items.length) return;
          const itemWidth = items[0].offsetWidth;
          const gap = parseFloat(getComputedStyle(scroll).columnGap) || 0;
          const pageWidth = itemsPerPage * itemWidth + (itemsPerPage - 1) * gap;
          scroll.scrollTo({ left: page * pageWidth, behavior: 'smooth' });
        });
      });

      updateDots();
    });
  };

  const initTdImageWithTemperatureScale = () => {
    const roots = document.querySelectorAll('[data-td-temperature-scale]');
    if (!roots.length) return;

    const readImageMap = (root) => {
      const script = root.querySelector('script[data-td-temperature-scale-images]');
      if (!script) return {};

      try {
        return JSON.parse(script.textContent || '{}');
      } catch (error) {
        return {};
      }
    };

    const applyImage = (image, data) => {
      if (!image) return;

      if (data?.src) {
        image.src = data.src;
        image.dataset.tdTemperatureScaleCurrent = data.src;
      } else if (image.dataset.tdTemperatureScaleFallbackSrc) {
        image.src = image.dataset.tdTemperatureScaleFallbackSrc;
        image.dataset.tdTemperatureScaleCurrent = image.dataset.tdTemperatureScaleFallbackSrc;
      }

      if (data?.srcset) {
        image.srcset = data.srcset;
      } else if (image.dataset.tdTemperatureScaleFallbackSrcset) {
        image.srcset = image.dataset.tdTemperatureScaleFallbackSrcset;
      } else {
        image.removeAttribute('srcset');
      }

      if (data?.alt != null) {
        image.alt = data.alt;
      } else if (image.dataset.tdTemperatureScaleFallbackAlt != null) {
        image.alt = image.dataset.tdTemperatureScaleFallbackAlt;
      }
    };

    const readGalleryImage = (imageIndex) => {
      const gallery = document.querySelector('product-gallery');
      if (!gallery) return null;

      const images = Array.from(
        gallery.querySelectorAll('.product-gallery__media:not([hidden]) img')
      ).filter((galleryImage) => galleryImage.currentSrc || galleryImage.src);

      const galleryImage = images[imageIndex];
      if (!galleryImage) return null;

      return {
        src: galleryImage.currentSrc || galleryImage.src,
        srcset: galleryImage.getAttribute('srcset') || '',
        alt: galleryImage.getAttribute('alt') || ''
      };
    };

    const hydrateRoot = (root) => {
      const image = root.querySelector('[data-td-temperature-scale-image]');
      if (!image) return null;

      image.dataset.tdTemperatureScaleFallbackSrc = image.currentSrc || image.src || '';
      image.dataset.tdTemperatureScaleFallbackSrcset = image.getAttribute('srcset') || '';
      image.dataset.tdTemperatureScaleFallbackAlt = image.getAttribute('alt') || '';

      return {
        image,
        useGalleryImage: root.dataset.tdTemperatureScaleUseGalleryImage === 'true',
        galleryImageIndex: Math.max(
          0,
          parseInt(root.dataset.tdTemperatureScaleGalleryImageIndex || '1', 10) || 1
        ),
        imageMap: readImageMap(root)
      };
    };

    const instances = Array.from(roots).map(hydrateRoot).filter(Boolean);
    if (!instances.length) return;

    const refreshFromGallery = () => {
      instances.forEach(({ image, useGalleryImage, galleryImageIndex }) => {
        if (useGalleryImage) {
          const galleryImage = readGalleryImage(galleryImageIndex);
          if (galleryImage) {
            applyImage(image, galleryImage);
          }
        }
      });
    };

    refreshFromGallery();

    document.addEventListener('product:rerender', () => {
      requestAnimationFrame(refreshFromGallery);
    });

    document.addEventListener('variant:change', (event) => {
      const variantId = event.detail?.variant?.id;
      if (!variantId) return;

      requestAnimationFrame(() => {
        instances.forEach(({ image, useGalleryImage, galleryImageIndex, imageMap }) => {
          const galleryImage = readGalleryImage(galleryImageIndex);
          if (useGalleryImage && galleryImage) {
            applyImage(image, galleryImage);
          } else {
            applyImage(image, imageMap[String(variantId)]);
          }
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initDeliveryTime();
      initTdVariantPicker();
      initTdCollectionProducts();
      initTdUpsellAddon();
      initTdImageWithTemperatureScale();
      initCertificatesDots();
    });
  } else {
    initDeliveryTime();
    initTdVariantPicker();
    initTdCollectionProducts();
    initTdUpsellAddon();
    initTdImageWithTemperatureScale();
    initCertificatesDots();
  }
})();
